import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validator, Validators } from '@angular/forms';
import { InputText } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { NewsletterService } from '../api/services/newsletter.service';

@Component({
  selector: 'app-newsletter',
  imports: [
    InputText,
    ReactiveFormsModule,
    MessageModule,
    CommonModule
  ],
  providers: [
    NewsletterService
  ],
  templateUrl: './newsletter.component.html',
  styleUrl: './newsletter.component.scss'
})
export class NewsletterComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly messageService = inject(MessageService);
  private readonly newsletterService = inject(NewsletterService);
  form!: FormGroup;
  loading: boolean = false;

  ngOnInit(): void {
    this.form = this.fb.group({
      email: [null, [Validators.required, Validators.email]]
    });
  }

  submit() {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Email inválido',
        detail: 'Verifique o email digitado!',
        life: 5000
      });
      return;
    }

    this.loading = true;
    const payload = {
      id: 0,
      email: this.form.get('email')?.value,
    }

    this.newsletterService.store(payload).subscribe({
      next: (res: any) => {
        if (res.retorno.codigo === 200) {
          this.messageService.add({
            severity: 'success',
            summary: 'Seu email foi subescrito',
            detail: 'Obrigado por subescrever a nossa newsletter!',
            life: 5000
          });
          this.form.reset();
          this.loading = false;
        } else {
          this.messageService.add({
            severity: 'warn',
            summary: 'Informação',
            detail: `${res.retorno.mensagem}` || 'Não foi possível subescrever o seu email',
            life: 5000
          });
          this.loading = false;
        }
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Informação',
          detail: `${err.retorno.mensagem}` || 'Erro ao subescrever o seu email',
          life: 5000
        });
        console.error(err);
        this.loading = false;
      },
    })
  }
}
